import { createContext, useReducer } from 'react';

import customersReducer from './customersReducer';

export const CustomerContext = createContext();

const INITIAL_STATE = {
    customers: [],
    selectedCustomer: null,
    isFreezeModalOpen: false,
    isUnfreezeModalOpen: false,
    isDeactivateModalOpen: false,
    isEditSpendLimitModalOpen: false,
    reloadCustomers: 0
};
export const CustomerProvider = ({ children }) => {
    const [state, dispatch] = useReducer(customersReducer, { ...INITIAL_STATE });

    return (
        <CustomerContext.Provider
            value={{
                dispatch,
                state
            }}>
            {children}
        </CustomerContext.Provider>
    );
};
